import { useTranslation } from 'react-i18next';

/**
 * 通用枚举 code 转 i18n 文案 hook：按 `${prefix}.${code}` 查字典，查不到就原样展示 code。
 * 内部走 useTranslation()，语言切换时使用方组件会自动重渲染、文案跟着更新。
 */
export function useEnumLabel(prefix: string) {
    const { t } = useTranslation();
    return (code: string | number | undefined | null): string => {
        if (code === undefined || code === null || code === '') return '-';
        return t(`${prefix}.${code}`) || String(code);
    };
}
